export const userData = [
    {
      name: 'Jan',
      "Active User": 4000,
    },
    {
      name: 'Feb',
      "Active User": 3000,
    },
    {
      name: 'Mar',
      "Active User": 2000,
    },
    {
      name: 'Apr',
      "Active User": 2780,
    },
    {
      name: 'May',
      "Active User": 1890,
    },
    {
      name: 'Jun',
      "Active User": 2390,
    },
    {
      name: 'Jul',
      "Active User": 7490,
    },
    {
        name: 'Aug',
        "Active User": 3490,
      },
      {
        name: 'Sep',
        "Active User": 5790,
      },
      {
        name: 'Oct',
        "Active User": 1890,
      },
      {
        name: 'Nov',
        "Active User": 2470,
      },
      {
        name: 'Dec',
        "Active User": 6990,
      },
  ];
export const productData = [
    {
      name: 'Jan',
      "Sales": 4000,
    },
    {
      name: 'Feb',
      "Sales": 3000,
    },
    {
      name: 'Mar',
      "Sales": 2000,
    }
  ];
  
  export const userRows = [
    {
      id: 1,
      username: "Lim Snow",
      avatar:
        "https://media-exp1.licdn.com/dms/image/C4D03AQGBTzB8o40FiQ/profile-displayphoto-shrink_800_800/0/1632340179895?e=1642636800&v=beta&t=z2h1yaq45K-S09EJia8X76SnZhHlDMsgg-tYo0aENu0",
      email: "limotalk@gmail.com",
      status: "active",
      transaction: "$120,00",
    },
    {
      id: 2,
      username: "Lim Snow",
      avatar:
        "https://media-exp1.licdn.com/dms/image/C4D03AQGBTzB8o40FiQ/profile-displayphoto-shrink_800_800/0/1632340179895?e=1642636800&v=beta&t=z2h1yaq45K-S09EJia8X76SnZhHlDMsgg-tYo0aENu0",
      email: "limotalk@gmail.com",
      status: "active",
      transaction: "$120,00",
    },
    {
      id: 3,
      username: "Lim Snow",
      avatar:
        "https://media-exp1.licdn.com/dms/image/C4D03AQGBTzB8o40FiQ/profile-displayphoto-shrink_800_800/0/1632340179895?e=1642636800&v=beta&t=z2h1yaq45K-S09EJia8X76SnZhHlDMsgg-tYo0aENu0",
      email: "limotalk@gmail.com",
      status: "active",
      transaction: "$120,00",
    },
    {
      id: 4,
      username: "Lim Snow",
      avatar:
        "https://media-exp1.licdn.com/dms/image/C4D03AQGBTzB8o40FiQ/profile-displayphoto-shrink_800_800/0/1632340179895?e=1642636800&v=beta&t=z2h1yaq45K-S09EJia8X76SnZhHlDMsgg-tYo0aENu0",
      email: "limotalk@gmail.com",
      status: "active",
      transaction: "$120,00",
    },
    {
      id: 5,
      username: "Lim Snow",
      avatar:
        "https://media-exp1.licdn.com/dms/image/C4D03AQGBTzB8o40FiQ/profile-displayphoto-shrink_800_800/0/1632340179895?e=1642636800&v=beta&t=z2h1yaq45K-S09EJia8X76SnZhHlDMsgg-tYo0aENu0",
      email: "limotalk@gmail.com",
      status: "active",
      transaction: "$120,00",
    },

    {
      id: 6,
      username: "Lim Snow",
      avatar:
        "https://media-exp1.licdn.com/dms/image/C4D03AQGBTzB8o40FiQ/profile-displayphoto-shrink_800_800/0/1632340179895?e=1642636800&v=beta&t=z2h1yaq45K-S09EJia8X76SnZhHlDMsgg-tYo0aENu0",
      email: "limotalk@gmail.com",
      status: "active",
      transaction: "$120,00",
    },
    {
      id: 7,
      username: "Lim Snow",
      avatar:
        "https://media-exp1.licdn.com/dms/image/C4D03AQGBTzB8o40FiQ/profile-displayphoto-shrink_800_800/0/1632340179895?e=1642636800&v=beta&t=z2h1yaq45K-S09EJia8X76SnZhHlDMsgg-tYo0aENu0",
      email: "limotalk@gmail.com",
      status: "active",
      transaction: "$120,00",
    },
    {
      id: 8,
      username: "Lim Snow",
      avatar:
        "https://media-exp1.licdn.com/dms/image/C4D03AQGBTzB8o40FiQ/profile-displayphoto-shrink_800_800/0/1632340179895?e=1642636800&v=beta&t=z2h1yaq45K-S09EJia8X76SnZhHlDMsgg-tYo0aENu0",
      email: "limotalk@gmail.com",
      status: "active",
      transaction: "$120,00",
    },

    {
      id: 9,
      username: "Lim Snow",
      avatar:
        "https://media-exp1.licdn.com/dms/image/C4D03AQGBTzB8o40FiQ/profile-displayphoto-shrink_800_800/0/1632340179895?e=1642636800&v=beta&t=z2h1yaq45K-S09EJia8X76SnZhHlDMsgg-tYo0aENu0",
      email: "limotalk@gmail.com",
      status: "active",
      transaction: "$120,00",
    },
    {
      id: 10,
      username: "Lim Snow",
      avatar:
        "https://media-exp1.licdn.com/dms/image/C4D03AQGBTzB8o40FiQ/profile-displayphoto-shrink_800_800/0/1632340179895?e=1642636800&v=beta&t=z2h1yaq45K-S09EJia8X76SnZhHlDMsgg-tYo0aENu0",
      email: "limotalk@gmail.com",
      status: "active",
      transaction: "$120,00",
    },
  ];
  export const productRows = [
    {
      id: 1,
      name: "Apple Iphone 13",
      img:
        "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/B/O/67343_1633016008.jpg",
      stock: 145,
      status: "active",
      price: "$120,00",
    },
    {
      id: 2,
      name: "Apple Iphone 13",
      img:
        "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/B/O/67343_1633016008.jpg",
      stock: 145,
      status: "active",
      price: "$120,00",
    },
    {
      id: 3,
      name: "Apple Iphone 13",
      img:
        "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/B/O/67343_1633016008.jpg",
      stock: 145,
      status: "active",
      price: "$120,00",
    },
    {
      id: 4,
      name: "Apple Iphone 13",
      img:
        "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/B/O/67343_1633016008.jpg",
      stock: 145,
      status: "active",
      price: "$120,00",
    },
    {
      id: 5,
      name: "Apple Iphone 13",
      img:
        "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/B/O/67343_1633016008.jpg",
      stock: 145,
      status: "active",
      price: "$120,00",
    },

    {
      id: 6,
      name: "Apple Iphone 13",
      img:
        "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/B/O/67343_1633016008.jpg",
      stock: 145,
      status: "active",
      price: "$120,00",
    },
    {
      id: 7,
      name: "Apple Iphone 13",
      img:
        "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/B/O/67343_1633016008.jpg",
      stock: 145,
      status: "active",
      price: "$120,00",
    },
    {
      id: 8,
      name: "Apple Iphone 13",
      img:
        "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/B/O/67343_1633016008.jpg",
      stock: 145,
      status: "active",
      price: "$120,00",
    },

    {
      id: 9,
      name: "Apple Iphone 13",
      img:
        "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/B/O/67343_1633016008.jpg",
      stock: 145,
      status: "active",
      price: "$120,00",
    },
    {
      id: 10,
      name: "Apple Iphone 13",
      img:
        "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/B/O/67343_1633016008.jpg",
      stock: 145,
      status: "active",
      price: "$120,00",
    },
  ];